<template>
    <el-dialog
        :visible="isVisible"
        @close="hide"
        :title="title"
        :destroy-on-close="true"
    >
        <loading v-if="!isInitialized"></loading>
        <campaign-view
            v-if="isInitialized"
            v-bind="formData"
        ></campaign-view>
    </el-dialog>
</template>

<script>
  import BaseDialogFormWrapper from '../../components/dialog-form-wrapper';
  import eventBus from '../../event-bus';
  import Loading from '../../components/loading';
  import CampaignView from '../../components/campaign/view';

  export default {
    extends: BaseDialogFormWrapper,

    components: {
      Loading,
      CampaignView,
    },

    computed: {
      /**
       * @return {string}
       */
      title() {
        if (!this.isInitialized) {
          return 'Loading ...';
        }

        return 'View Campaign';
      },
    },

    created() {
      eventBus.$on('show-view-campaign-dialog', this.show);
    },

    beforeDestroy() {
      eventBus.$off('show-view-campaign-dialog', this.show);
    }
  }
</script>
